import React, { Component } from 'react';

import {
  updateQueryString,
  getOfferDescription,
  get_hotel_facts
} from '../../../../services/services';
import ProvidersSelect from './providers_select';
import Loader from '../../../../common/components/loader';
import { T } from '../../../../../../common/locale/translate';
import { trackAnalyticsEvent } from '../../../../services/analytics';

export default class DescriptionTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      description: props.description,
      facts: [],
      facts_language: 'pl',

      descriptionProviders: props.descriptionProviders,
      currentProviderCode: this.prepareDefaultProvider(),
      isDescriptionOriginal: true,
      descriptionLanguage: this.prepareDefaultDescriptionLanguage(),

      hotelId: props.hotelId,
      parser: props.parser,

      isLoaderVisible: true,
      isFactsLoaderVisible: true,

      wrapFactsAfterNth: 6,

      are_hotel_facts_open: false,
      are_rooms_facts_open: false,
      are_additional_facts_open: false,

      hotel_facts_button: T('show_more'),
      rooms_facts_button: T('show_more'),
      additional_facts_button: T('show_more')
    };
  }

  componentDidMount() {
    let params = this.descriptionParams();
    let facts_params = this.factsParams();
    this.loadProviderDescription(params);
    this.loadHotelFacts(facts_params);
  }

  render() {
    let buttonVersionText = this.state.isDescriptionOriginal
      ? T('show_translation')
      : T('show_original_text');
    let descriptionExplanation = this.state.isDescriptionOriginal
      ? T('description_is_original')
      : T('description_is_translated');
    let stars_rating = this.props.starsRating
      ? this.props.starsRating.toString().replace('.', '')
      : '';
    let is_amigos_description = this.isAmigosDescription()
      ? 'amigos-description'
      : 'forein-description';

    const is_description_exportable =
      this.props.allow_description_export &&
      this.state.description &&
      typeof window !== 'undefined';

    const can_description_be_translated = !(
      this.state.isDescriptionOriginal &&
      this.props.client_language === this.state.descriptionLanguage
    );
    const description_additional_information = can_description_be_translated
      ? T('providers_description_explanation')
      : T('providers_description_explanation_not_translatable');

    return (
      <div className="offer-description">
        <div className="description-title">
          <h3>{this.props.offerName}</h3>
          <span className={`stars stars-${stars_rating}`} />
        </div>
        <div className="provider-controll">
          <span>{T('change_description_provider')}:</span>
          <ProvidersSelect
            handleChange={this.getCodeFromSelect.bind(this)}
            providers={this.state.descriptionProviders}
            defaultProviderCode={this.state.currentProviderCode}
          />
          <div
            className={`about-description${
              is_description_exportable ? ' exportable' : ''
            }`}
          >
            {T('about_description_provider')}
          </div>
          {is_description_exportable && (
            <a className="export-pdf-button" href={this.downloadPdfUrl()}>
              {T('export_to_pdf')}
            </a>
          )}
        </div>

        <div className="facts">
          <Loader
            active={this.state.isFactsLoaderVisible}
            className="facts-loader"
          />
          {this.is_facilities_section_visible(this.state.facts) && (
            <p className="facts-type">{T('equipment_and_facilities')}</p>
          )}
          {this.render_inside_hotel(this.state.facts)}
          {this.render_inside_rooms(this.state.facts)}
          {this.render_additional_attractions(this.state.facts)}

          {this.is_contact_and_localization_section_visible(
            this.state.facts
          ) && <p className="facts-type">{T('contact_and_localization')}</p>}
          {this.render_localization(this.state.facts)}
          {this.render_contact_informations(this.state.facts)}
        </div>

        <p className="facts-type about-hotel">{T('about_hotel')}</p>
        <div className="description-control">
          <div className="icon-container">
            <img
              src="/img/icons/explanation_mark.svg"
              alt={T('explanation_mark')}
            />
          </div>
          <div className="text-container">
            <span className="explanation">{descriptionExplanation}</span>
            <div className="contact-information">
              <span>{description_additional_information}</span>
              <a
                href={`tel:${T('office_phone_number_no_spaces')}`}
                title={T('call_us_phone')}
                onClick={() =>
                  trackAnalyticsEvent(
                    'kontakt z biurem',
                    'telefon',
                    'telefon stacjonarny - w opisie hotelu'
                  )
                }
                dangerouslySetInnerHTML={{
                  __html: T('office_phone_number')
                }}
              />
              <span>{T('or_email')}</span>
              <a
                href={`mailto:${T('office_email')}`}
                title={T('contact_us')}
                onClick={() =>
                  trackAnalyticsEvent(
                    'kontakt z biurem',
                    'email',
                    'email w opisie hotelu'
                  )
                }
              >
                {T('office_email')}
              </a>
              <span>{T('or_ask_about_offer')}</span>
            </div>
            {can_description_be_translated && (
              <span
                className="trigger-wrapper"
                onClick={this.changeDescriptionLanguage}
              >
                <a rel="nofollow" className="version-trigger">
                  {buttonVersionText}
                </a>
              </span>
            )}
          </div>
        </div>

        <div>
          <Loader
            active={this.state.isLoaderVisible}
            className="description-loader"
          />
          <div
            className={`description-wrapper noselect ${is_amigos_description}`}
            lang={
              this.state.descriptionLanguage
                ? this.state.descriptionLanguage
                : this.props.client_language
            }
            dangerouslySetInnerHTML={{ __html: this.state.description }}
          />
        </div>
      </div>
    );
  }
  renderOptions = () => {
    let providers = this.state.descriptionProviders;
    return providers.map((option, index) => (
      <option value={option.code} key={index}>
        {option.name}
      </option>
    ));
  };

  loadProviderDescription = params => {
    getOfferDescription(params)
      .then(response => {
        let descriptionData = response.data;
        this.setState({
          description: descriptionData.description,
          isDescriptionOriginal: descriptionData.is_original,
          descriptionLanguage: descriptionData.language,
          isLoaderVisible: false
        });
      })
      .catch(error => {
        console.log('An error occoured: ' + error);
        this.setState({
          isLoaderVisible: false,
          description: T('an_error_has_occurred')
        });
      });
  };

  changeDescriptionLanguage = () => {
    let isOriginal = this.state.isDescriptionOriginal;
    let newLanguage =
      this.state.descriptionLanguage === this.props.client_language
        ? ''
        : this.props.client_language;

    this.setState(
      {
        descriptionVersion: !isOriginal,
        descriptionLanguage: newLanguage,
        isLoaderVisible: true
      },
      () => {
        let newParams = this.descriptionParams();
        this.loadProviderDescription(newParams);
      }
    );
  };

  loadHotelFacts = params => {
    get_hotel_facts(params)
      .then(response => {
        let hotel_facts = response.data;
        this.setState({
          facts: hotel_facts,
          isFactsLoaderVisible: false
        });
      })
      .catch(error => {
        console.log('An error occoured: ' + error);
        this.setState({
          isFactsLoaderVisible: false,
          facts: []
        });
      });
  };

  getCodeFromSelect = code => {
    let providers = this.state.descriptionProviders;
    let matched_provider_from_array = providers.filter(o => {
      return o.code === code.trim();
    })[0];
    this.setState(
      {
        currentProviderCode: code,
        descriptionLanguage: matched_provider_from_array.is_translation_in_db
          ? this.props.client_language
          : '',
        isLoaderVisible: true,
        isFactsLoaderVisible: true
      },
      () => {
        let params = this.descriptionParams();
        this.loadProviderDescription(params);

        let facts_params = this.factsParams();
        this.loadHotelFacts(facts_params);
      }
    );
  };

  descriptionParams = () => {
    return {
      id: this.state.hotelId,
      operator_code: this.state.currentProviderCode,
      parser: this.state.parser,
      language: this.state.descriptionLanguage
    };
  };

  factsParams = () => {
    return {
      hotel_id: this.state.hotelId,
      parser: this.state.parser,
      lang: this.state.facts_language,
      operator_code: this.state.currentProviderCode
    };
  };

  prepareDefaultProvider = () => {
    const availableProviders = this.props.descriptionProviders;
    const providerFromParamsCode = this.props.originalProvider.code;
    const priorityCode = this.props.operator_priority_code;
    let filtered_providers = availableProviders.filter(p => {
      return p.code == priorityCode;
    });
    let is_amigos_provider_present = filtered_providers.length > 0;
    return is_amigos_provider_present ? priorityCode : providerFromParamsCode;
  };

  prepareDefaultDescriptionLanguage = () => {
    // if params[:language] is set, then set this language as default
    if (this.props.default_language) {
      return this.props.default_language;
    } else {
      const availableProviders = this.props.descriptionProviders;
      const match_provider_from_database = availableProviders.filter(p => {
        return p.code === this.prepareDefaultProvider();
      });

      if (match_provider_from_database.length > 0) {
        // sometimes there is no description for chosen offer provided by operator (operator_code in URL on offer page)
        return match_provider_from_database[0].is_translation_in_db
          ? this.props.client_language
          : '';
      } else {
        return '';
      }
    }
  };

  render_inside_hotel = facts => {
    let options = {
      class_name: 'inside-hotel',
      title: T('inside_hotel'),
      items: typeof facts != 'undefined' ? facts.facilities : [],
      icon: 'home',

      wrap_after_nth: this.state.wrapFactsAfterNth,
      button_text: this.state.hotel_facts_button,
      are_facts_open: this.state.are_hotel_facts_open,
      is_wrapable: true,
      group_prefix: 'hotel'
    };
    return this.facts_section(options);
  };

  render_inside_rooms = facts => {
    let options = {
      class_name: 'inside-rooms',
      title: T('inside_rooms'),
      items: typeof facts != 'undefined' ? facts.rooms : [],
      icon: 'bed',

      wrap_after_nth: this.state.wrapFactsAfterNth,
      button_text: this.state.rooms_facts_button,
      are_facts_open: this.state.are_rooms_facts_open,
      is_wrapable: true,
      group_prefix: 'rooms'
    };
    return this.facts_section(options);
  };

  render_additional_attractions = facts => {
    let options = {
      class_name: 'additional-attractions',
      title: T('additional_attractions'),
      items:
        typeof facts != 'undefined' && facts.spa
          ? facts.spa.concat(facts.entertainment, facts.sports)
          : [],
      icon: '',

      wrap_after_nth: this.state.wrapFactsAfterNth,
      button_text: this.state.additional_facts_button,
      are_facts_open: this.state.are_additional_facts_open,
      is_wrapable: true,
      group_prefix: 'additional'
    };
    return this.facts_section(options);
  };

  render_contact_informations = facts => {
    let contact_info = typeof facts != 'undefined' ? facts.object : [],
      list_order = ['address', 'phone', 'url', 'fax', 'email'],
      ordered_list = this.order_facts_by_type(list_order, contact_info);

    let options = {
      class_name: 'contact-informations',
      title: T('contact_informations'),
      items: ordered_list,
      icon: 'info-circle',

      is_wrapable: false
    };
    return this.facts_section(options);
  };

  render_localization = facts => {
    let options = {
      class_name: 'hotel-localization',
      title: T('localization'),
      items:
        typeof facts != 'undefined' && facts.surroundings
          ? facts.surroundings.concat(facts.location)
          : [],
      icon: 'compass',

      is_wrapable: false
    };
    return this.facts_section(options);
  };

  facts_section = options => {
    if (typeof options.items == 'undefined' || options.items.length <= 0) {
      return;
    }
    let is_button_visible =
      options.is_wrapable && options.items.length > options.wrap_after_nth;
    let facts_section = (
      <ul>
        {options.items.map((item, index) => {
          return (
            <li
              key={index}
              className={`${item.type} ${
                options.is_wrapable && index + 1 > options.wrap_after_nth
                  ? 'mobile-wrapable'
                  : ''
              }`}
            >
              {item.name}
            </li>
          );
        })}
        {is_button_visible && (
          <li className="show-more">
            <div
              onClick={() => this.toggleFacts(options.group_prefix)}
              className="show-more-button"
            >
              <span>{options.button_text}</span>
              <span
                className={`fa fa-chevron-${
                  options.are_facts_open ? 'up' : 'down'
                }`}
              />
            </div>
          </li>
        )}
      </ul>
    );

    return (
      <div
        className={`${options.class_name} facts-section ${
          options.are_facts_open ? 'open' : ''
        }`}
      >
        <h4>
          <i className={`fa fa-${options.icon}`} />
          {options.title}
        </h4>
        {facts_section}
      </div>
    );
  };

  is_facilities_section_visible = facts => {
    let facilities =
      typeof facts != 'undefined' && facts.facilities
        ? facts.facilities.concat(
            facts.facilities,
            facts.rooms,
            facts.spa,
            facts.entertainment,
            facts.sports
          )
        : [];
    return facilities.length > 0;
  };

  is_contact_and_localization_section_visible = facts => {
    let object_info =
      typeof facts != 'undefined' && facts.object
        ? facts.object.concat(facts.surroundings, facts.location)
        : [];
    return object_info.length > 0;
  };

  order_facts_by_type = (list_order, list) => {
    if (typeof list == 'undefined' || list.length == 0) {
      return [];
    }
    let ordered = [];
    list_order.map(key => {
      list.map(element => {
        if (element.type == key) {
          ordered.push(element);
        }
      });
    });
    return ordered;
  };

  isAmigosDescription = () => {
    return this.props.operator_priority_code == this.state.currentProviderCode;
  };

  toggleFacts = group_name => {
    let are_open = this.state[`are_${group_name}_facts_open`];
    let button_text = !are_open ? T('show_less') : T('show_more');

    let newState = {};
    newState[`are_${group_name}_facts_open`] = !are_open;
    newState[`${group_name}_facts_button`] = button_text;

    this.setState({ ...newState });
  };

  downloadPdfUrl = () => {
    let url = updateQueryString('format', 'pdf', window.location.href);
    url = updateQueryString(
      'operator_code',
      this.state.currentProviderCode,
      url
    );
    url = updateQueryString('language', this.state.descriptionLanguage, url);
    return updateQueryString('download', 'true', url);
  };
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/descriptions/description_tab.jsx